/**
 * True when a string is just the station billing itself — "91.7FM KVRX",
 * "KVRX 91.7 FM" and friends.
 */
function isStationName(value) {
  if (typeof value !== "string") return false;

  const squashed = value.toLowerCase().replace(/[^a-z0-9]/g, "");
  if (!/^(kvrx|917|fm)+$/.test(squashed)) return false;

  // Guard against a real act called "FM": require the callsign or the dial.
  return squashed.includes("kvrx") || squashed.includes("917");
}

/**
 * The artist to display, or null when there isn't one worth showing.
 *
 * While automation is driving the stream the API returns the station's own
 * name in the artist field. Rendered literally that reads as a band called
 * "91.7FM KVRX", and on the homepage it lands next to the logo, the hero
 * heading and the frequency lockup — the same fact four times over. The
 * frequency is already on screen, so this drops the duplicate rather than the
 * one people actually look at.
 */
export function displayArtist(song) {
  const artist = song?.artist;
  if (typeof artist !== "string" || !artist.trim()) return null;
  return isStationName(artist) ? null : artist;
}

/**
 * The tracks already aired in the current set, most recent first.
 *
 * `playlist.songs` is the show's log in PLAY ORDER, and it also contains
 * tracks the DJ has queued but not yet aired — so the tail of the list is the
 * future, not the past. The now-playing `id` matches the log's `id`, and that
 * position is the cut line: everything before it has aired, everything after
 * has not. Taking the last N instead would surface unplayed tracks and label
 * them as played.
 */
export function recentlyPlayed(playlist, song, limit = 5) {
  const songs = playlist?.songs;
  if (!Array.isArray(songs) || songs.length === 0) return [];
  if (song?.id === undefined || song?.id === null) return [];

  const current = songs.findIndex((entry) => entry.id === song.id);

  // -1: the current track isn't in this log (automation, or the log lagging).
  // 0: it's the first of the set, so nothing has aired before it.
  if (current <= 0) return [];

  return songs.slice(Math.max(0, current - limit), current).reverse();
}

export default recentlyPlayed;
